import PropTypes from 'prop-types';
import GeneralSection from '../laptop/GeneralSection/GeneralSection';
import GeneralSectionMobile from '../mobile/GeneralSection/GeneralSection';
import isMobileViewHook from '../../hooks/isMobileView';
import WithSubsections from '../WithSubsections/WithSubsections';

const SectionView = ({ section, onBackToTop }) => {
  const isMobileView = isMobileViewHook();
  const buttonPressedHandler = () => {};
  const storePressedHandler = () => {};
  switch (section.viewType) {
    case 'GENERAL':
      return isMobileView ? (
        <GeneralSectionMobile
          onBackToTop={onBackToTop}
          section={section}
          onButtonPressed={buttonPressedHandler}
          onStorePressed={storePressedHandler}
        />
      ) : (
        <GeneralSection
          section={section}
          onButtonPressed={buttonPressedHandler}
          onStorePressed={storePressedHandler}
        />
      );
    case 'WITH_SUBSECTIONS':
      return (
        <WithSubsections
          onBackToTop={onBackToTop}
          section={section}
          color={section.color}
        />
      );
    default:
      return <p>a</p>;
  }
};

SectionView.propTypes = {
  section: PropTypes.shape({
    viewType: PropTypes.oneOf(['GENERAL', 'WITH_SUBSECTIONS']),
    subsections: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    color: PropTypes.string.isRequired,
  }).isRequired,
  onBackToTop: PropTypes.func,
};

SectionView.defaultProps = {
  onBackToTop: () => {},
};

export default SectionView;
